import React, { useState } from 'react';
import PageTitle from '../../../layouts/PageTitle';
import ListPage from '../../../layouts/page/ListPage';
import MenuConfig from '../../../../constants/MenuConfig';
import { SaaSPlanColumns } from './SaaSPlanColumns';

const SaaSPlanList = () => {
    const [, setSelectedRows] = useState([]);
    return <><PageTitle activeMenu="Planos SaaS" motherMenu="Cobrança SaaS" /><ListPage showPageTitle={false} activeMenu="Planos SaaS" motherMenu="Cobrança SaaS" path="/saas-billing/plans" route={MenuConfig.superadmin.saas_billing.plansRoute} columns={SaaSPlanColumns} setSelectedRows={setSelectedRows} /></>;
};
export default SaaSPlanList;
